import { createRoot } from 'react-dom/client';

const container = document.getElementById('root');
const rootContainer = container && createRoot(container);

export default rootContainer;
